import { Component, OnInit } from '@angular/core';
import { ApiService, AlertService } from '../_services';
import { JwtHelper } from '../_services/jwt-helper';
import { Router } from '@angular/router';
import { Member } from '../_models';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {
  openIdTokenParams: any;
  memberId: any;
  currentMember: Member;
  constructor(private apiService: ApiService, private router: Router, private alertService: AlertService) { 
    this.openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
  }

  ngOnInit() {
    if(! this.openIdTokenParams) {
      this.router.navigate(["/login"],{ skipLocationChange: false, queryParamsHandling: 'merge',queryParams: { "returnUrl": "sso" }});
     // window.location.href="/login?returnUrl=sso"
      return;
    };
    this.loginSSOCareington();
  }

  loginSSOCareington(){

    let jwtHelper = new JwtHelper();
    let decodedIdToken = jwtHelper.decodeToken(this.openIdTokenParams.id_token);
    this.memberId = parseInt(decodedIdToken.sub);
    this.apiService.getMemberById(this.memberId).subscribe(m=>{   
      this.currentMember = m as Member;
          if(this.currentMember.memberSSOProviderStatuses.length > 0 && this.currentMember.memberSSOProviderStatuses[0].status == 0)
          {
              this.alertService.error("Please contact support at 1-866-500-7065");
              $('html, body').animate({
                  scrollTop: ($('ng2-toasty').first().offset().top)
              },500);
              return;
          }
          this.apiService.ssoLogin(this.memberId, this.currentMember.currentProductId).subscribe(r=>{
            this.router.navigate(['/']);
              top.window.open( r.redirectSSOUrl, '_blank');
          });
    },err=>{
        console.log(err);
        this.router.navigate(["/login"],{ queryParamsHandling: 'merge',queryParams: { "returnUrl": "sso" }});
    })


}

}



// WEBPACK FOOTER //
// ./src/app/sso/sso.component.ts